import {
  SET_SEARCH_TEXT,
  SET_SELECTED_STATUS,
  SET_ONLY_ATIVOS,
} from './mutations.type';

export default {
  [SET_SELECTED_STATUS](state, selectedStatus) {
    state.selectedStatus = selectedStatus;
  },
  [SET_SEARCH_TEXT](state, searchText) {
    state.searchText = searchText;
  },
  [SET_ONLY_ATIVOS](state, onlyAtivos) {
    state.onlyAtivos = onlyAtivos;
  },
};
